// Geometria del sello de firma visible sobre una pagina del PDF.
//
// Espejo de facturaelectronica/PDFSignatureManager.py: el dashboard trabaja en
// "espacio de pantalla" (fracciones 0..1 del area visible de la pagina, origen
// arriba-izquierda, igual que CSS) y el backend traduce eso al espacio de
// usuario del PDF, donde ademas resuelve /Rotate y el origen del MediaBox.
// Manteniendo aqui los mismos minimos y el mismo tamaño por defecto, lo que el
// usuario ve arrastrando es lo que termina estampado.

export const STAMP_WIDTH = 280;         // puntos PDF
export const STAMP_HEIGHT = 80;
export const STAMP_MARGIN_X = 40;       // margen por defecto desde la izquierda
export const STAMP_MARGIN_Y = 30;       // margen por defecto desde abajo
export const MIN_STAMP_WIDTH = 110;     // bajo esto el QR deja de ser escaneable
export const MIN_STAMP_HEIGHT = 40;

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

// Los minimos se expresan en puntos, pero el placement viaja en fracciones: en
// paginas mas chicas que el minimo el limite pasa a ser la pagina entera.
function minSize(pageWidth, pageHeight) {
    return {
        width: Math.min(MIN_STAMP_WIDTH, pageWidth) / pageWidth,
        height: Math.min(MIN_STAMP_HEIGHT, pageHeight) / pageHeight,
    };
}

export function clampPlacement(placement, pageWidth, pageHeight) {
    const min = minSize(pageWidth, pageHeight);
    const width = clamp(placement.width, min.width, 1);
    const height = clamp(placement.height, min.height, 1);
    return {
        page: placement.page,
        x: clamp(placement.x, 0, 1 - width),
        y: clamp(placement.y, 0, 1 - height),
        width: width,
        height: height,
    };
}

// Misma esquina inferior izquierda que usaba el firmador antes de que la
// ubicacion fuera configurable.
export function defaultPlacement(page, pageWidth, pageHeight) {
    const height = Math.min(STAMP_HEIGHT, pageHeight) / pageHeight;
    return clampPlacement({
        page: page,
        x: STAMP_MARGIN_X / pageWidth,
        y: 1 - height - (STAMP_MARGIN_Y / pageHeight),
        width: Math.min(STAMP_WIDTH, pageWidth) / pageWidth,
        height: height,
    }, pageWidth, pageHeight);
}

export function movePlacement(placement, dx, dy, pageWidth, pageHeight) {
    return clampPlacement({
        page: placement.page,
        x: placement.x + dx,
        y: placement.y + dy,
        width: placement.width,
        height: placement.height,
    }, pageWidth, pageHeight);
}

// `handle` es una esquina: 'nw', 'ne', 'sw' o 'se'. Recortamos el delta contra
// el borde opuesto para que ese borde no se mueva al llegar al minimo.
export function resizePlacement(placement, handle, dx, dy, pageWidth, pageHeight) {
    const min = minSize(pageWidth, pageHeight);
    const right = placement.x + placement.width;
    const bottom = placement.y + placement.height;
    let x = placement.x;
    let y = placement.y;
    let width = placement.width;
    let height = placement.height;

    if (handle.indexOf('e') >= 0) {
        width = clamp(placement.width + dx, min.width, 1 - x);
    }
    if (handle.indexOf('w') >= 0) {
        x = clamp(placement.x + dx, 0, right - min.width);
        width = right - x;
    }
    if (handle.indexOf('s') >= 0) {
        height = clamp(placement.height + dy, min.height, 1 - y);
    }
    if (handle.indexOf('n') >= 0) {
        y = clamp(placement.y + dy, 0, bottom - min.height);
        height = bottom - y;
    }

    return clampPlacement({ page: placement.page, x: x, y: y, width: width, height: height }, pageWidth, pageHeight);
}
